<table class="table table-hover">
        <thead style="  background: #182F7C;color: #FFFFFF;
    ">
        <tr>
            <th style="border-radius: 18px 0px 0px 0px;
" scope="col">Segment</th>
            <th scope="col" style="border-radius: 0px 18px 0px 0px;">Amount (AED)</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>Otto</td>
            <td>@mdo</td>
        </tr>
        <tr>
            <td>Thornton</td>
            <td>@fat</td>
        </tr>
        </tbody>
    </table>


